module.exports = __webpack_public_path__ + "img/Mockup_0.5ab24d1f.jpg";